import { render, staticRenderFns } from "./masterKuesioner.vue?vue&type=template&id=79b70a36&"
import script from "./masterKuesioner.vue?vue&type=script&lang=js&"
export * from "./masterKuesioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
